import { useCostCenterNumbersService } from '@/views/Administration/Users/services/costCenterNumbersService'
import { useMaintenanceAccidentsService } from '@/views/Maintenance/services/maintenanceAccidentsService'

export function createMaintenanceAccidentsActions(state) {
    const maintenanceAccidentsService = useMaintenanceAccidentsService()
    const costCenterNumbersService = useCostCenterNumbersService()

    const fetchAccidents = async (args = {}) => {
        try {
            state.accidentsLoading.value = true
            const response = await maintenanceAccidentsService.fetchAccidents(args)
            state.accidents.value = response.data.results || []
            return response
        } finally {
            state.accidentsLoading.value = false
        }
    }

    const fetchAccident = async (accidentId) => {
        try {
            state.accidentLoading.value = true
            const response = await maintenanceAccidentsService.fetchAccident(accidentId)
            state.accident.value = response.data
            return response
        } finally {
            state.accidentLoading.value = false
        }
    }

    const fetchUnsolvedMachineAccidents = async (machineId) => {
        return await maintenanceAccidentsService.fetchUnsolvedMachineAccidents(machineId)
    }

    const fetchAccidentTypes = async () => {
        const response = await maintenanceAccidentsService.fetchAccidentTypes()
        state.accidentTypes.value = response.data.results || []
        return response
    }

    const fetchMachinesBasicData = async () => {
        const response = await maintenanceAccidentsService.fetchMachinesBasicData()
        state.machinesBasicData.value = response.data || []
        return response
    }

    const fetchSoftwareTypes = async () => {
        const response = await maintenanceAccidentsService.fetchSoftwareTypes()
        state.softwareTypes.value = response.data.results || response.data || []
        return response
    }

    const fetchCostCenterNumbers = async () => {
        const results = await costCenterNumbersService.fetchCostCenterNumbers()
        state.costCenterNumbers.value = results
        return results
    }

    const fetchAccidentStatuses = async () => {
        const response = await maintenanceAccidentsService.fetchAccidentStatuses()
        state.accidentStatuses.value = response.data.results || []
        return response
    }

    const fetchAccidentUserDepartments = async () => {
        const response = await maintenanceAccidentsService.fetchAccidentUserDepartments()
        state.accidentUserDepartments.value = response.data.results || []
        return response
    }

    const fetchAccidentDepartments = async () => {
        const response = await maintenanceAccidentsService.fetchAccidentDepartments()
        state.accidentDepartments.value = response.data.results || []
        return response
    }

    const fetchAccidentStatusHistory = async (accidentId) => {
        const response = await maintenanceAccidentsService.fetchAccidentStatusHistory(accidentId)
        state.accidentStatusHistory.value = response.data.results || []
        return response
    }

    const createAccident = async (payload) => {
        try {
            state.accidentLoading.value = true
            return await maintenanceAccidentsService.createAccident(payload)
        } finally {
            state.accidentLoading.value = false
        }
    }

    const updateAccident = async (payload) => {
        try {
            state.accidentLoading.value = true
            const response = await maintenanceAccidentsService.updateAccident(payload)

            const updated = response.data
            state.accident.value = updated

            const index = state.accidents.value.findIndex((item) => String(item.id) === String(updated.id))
            if (index >= 0) {
                state.accidents.value.splice(index, 1, updated)
            }

            return response
        } finally {
            state.accidentLoading.value = false
        }
    }

    const deleteAccident = async (accidentId) => {
        return await maintenanceAccidentsService.deleteAccident(accidentId)
    }

    const createAccidentComment = async (payload) => {
        return await maintenanceAccidentsService.createAccidentComment(payload)
    }

    const generateAccidentsReport = async ({ query = '', userEmail } = {}) => {
        return await maintenanceAccidentsService.generateAccidentsReport({ query, userEmail })
    }

    const setFilters = (filters) => {
        state.filters.value = { ...state.filters.value, ...filters }
    }

    const resetFilters = () => {
        state.filters.value = state.createInitialFilters()
    }

    const fetchAccidentDashboard = async ({ query = '' } = {}) => {
        try {
            state.accidentDashboardLoading.value = true
            const response = await maintenanceAccidentsService.fetchAccidentDashboard({ query })
            state.accidentDashboardItems.value = response.data || []
            return response
        } finally {
            state.accidentDashboardLoading.value = false
        }
    }

    const fetchAccidentDashboardMachines = async ({ query = '' } = {}) => {
        try {
            state.accidentDashboardMachinesLoading.value = true
            const response = await maintenanceAccidentsService.fetchAccidentDashboardMachines({ query })
            state.accidentDashboardMachines.value = response.data || []
            return response
        } finally {
            state.accidentDashboardMachinesLoading.value = false
        }
    }

    const setDashboardFilters = (filters) => {
        state.dashboardFilters.value = { ...state.dashboardFilters.value, ...filters }
    }

    const resetDashboardFilters = () => {
        state.dashboardFilters.value = state.createInitialDashboardFilters()
    }

    const generateAccidentDashboardReport = async ({ query = '', userEmail } = {}) => {
        return await maintenanceAccidentsService.generateAccidentDashboardReport({ query, userEmail })
    }

    return {
        fetchAccidents,
        fetchAccident,
        fetchUnsolvedMachineAccidents,
        fetchAccidentTypes,
        fetchMachinesBasicData,
        fetchSoftwareTypes,
        fetchCostCenterNumbers,
        fetchAccidentStatuses,
        fetchAccidentUserDepartments,
        fetchAccidentDepartments,
        fetchAccidentStatusHistory,
        createAccident,
        updateAccident,
        deleteAccident,
        createAccidentComment,
        generateAccidentsReport,
        setFilters,
        resetFilters,
        fetchAccidentDashboard,
        fetchAccidentDashboardMachines,
        setDashboardFilters,
        resetDashboardFilters,
        generateAccidentDashboardReport
    }
}
